import { Link } from "react-router-dom";
import { LOGO } from "../data/content";

const LEGAL_LINKS = [
  { label: "Mentions légales", to: "/mentions-legales#mentions-legales" },
  { label: "Politique de confidentialité", to: "/mentions-legales#confidentialite" },
  { label: "CGV", to: "/mentions-legales#cgv" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#E6EDF6] py-14">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO} alt="Elevate Influence" className="h-9 w-9 rounded-lg object-cover" />
            <span className="font-head text-lg font-extrabold text-[#0B1220]">
              Elevate<span className="text-[#3B82F6]"> Influence</span>
            </span>
          </Link>

          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium text-[#5B6B85]">
            <a href="/#realisations" className="transition-colors hover:text-[#0B1220]">Réalisations</a>
            <a href="/#cas" className="transition-colors hover:text-[#0B1220]">Études de cas</a>
            <a href="/#offre" className="transition-colors hover:text-[#0B1220]">Offre</a>
            <a href="/#faq" className="transition-colors hover:text-[#0B1220]">FAQ</a>
            <a href="/#offre" className="transition-colors hover:text-[#0B1220]">Contact</a>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-[#E6EDF6] pt-8 text-xs text-[#64748B] md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Elevate Influence · Viral Institution. Tous droits réservés.</p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2" data-testid="footer-legal">
            {LEGAL_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-legal-${l.to.split("#")[1]}`}
                className="transition-colors hover:text-[#2563EB]"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
